import { Network } from "../Network";
import { ContractorSubmittalsEndPoints } from "apis/EndPoints/ContractorSubmittalsEndPoints";

export class ContractorSubmittalsService {
  static procurementLogReadSpecificSubmittalContractor(data = {}) {
    return Network.fetch(
      ContractorSubmittalsEndPoints.procurementLogReadSpecificSubmittalContractor.url(
        data.company_id,
        data.id,
        data.entryID
      ),
      {
        headers: {
          "Content-type": "application/json",
          // Authorization: data?.code,
          From: data.email,
        },
        method:
          ContractorSubmittalsEndPoints
            .procurementLogReadSpecificSubmittalContractor.method,
      }
    );
  }
  static procurementLogContractorEditEntry(data = {}) {
    return Network.fetch(
      ContractorSubmittalsEndPoints.procurementLogContractorEditEntry.url(
        data.company_id,
        data.id
      ),
      {
        headers: {
          "Content-type": "application/json",
          // Authorization: data?.code,
          From: data.email,
        },
        method:
          ContractorSubmittalsEndPoints.procurementLogContractorEditEntry
            .method,
        body: JSON.stringify(data.entries),
      }
    );
  }
}
